import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import styles from "../../styles/ScholarshipsCountry.module.scss";
import CustomImage from "../CustomImage";
import Button from "react-bootstrap/Button";
import CountryPopularSholarshipProgramsComponent from "./PopularSholarshipPrograms";
import StudentsAcheivents from "../StudentsAcheivement";
import NeedGuidance from "../NeedGuidance";
import FaqComponent from "../PST/FrequentlyAskedQuestions";
import { isFrappeOrJotFormClass } from "../../utils/helpers";
import VideoTestimonials from "../PST/VideoTestimonials";

const StudyAbroadScholarshipCountryComponent: React.FC = (props: any) => {
  const scholarshipCountryData = props.pageData[0];
  return (
    <>
      <div id="countrySholarshipsPage">
        <div id="countrySholarshipsBanner" className={styles.countrySholarshipsPage}>
          <Container>
            <div className={styles.breadcrum}>
              <Row className="text-center">
                <Col lg={8} md={8} xs={12} className={styles.centered}>
                  <Breadcrumb>
                    <Breadcrumb.Item style={{ opacity: 0.5 }} href="/student-services/steps-to-study-abroad">
                      Services for Students
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{ opacity: 0.5 }} href="./">
                      Scholarships
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="">{scholarshipCountryData.scholarships_country?.countryName} </Breadcrumb.Item>
                  </Breadcrumb>
                  <div className={styles.abttopContent}>
                    <h1>{scholarshipCountryData.bannerSection?.title}</h1>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={12}>
                  <Row className={styles.parentMain}>
                    <Col lg={12} xs={12} md={12} sm={12}>
                      {/* desktop img */}
                      <div className="d-none d-sm-block">
                        <CustomImage
                          src={scholarshipCountryData.bannerSection?.desktopBannerImage?.url}
                          width={1100}
                          height={300}
                          alt={scholarshipCountryData.bannerSection?.desktopBannerImage?.alternativeText}
                          className={styles.borderRadiusImg}
                        />
                      </div>
                      {/* mobile img */}
                      <div className="d-block d-sm-none">
                        <CustomImage
                          src={scholarshipCountryData.bannerSection?.mobileBannerImage?.url}
                          width={341}
                          height={300}
                          alt={scholarshipCountryData.bannerSection?.mobileBannerImage?.alternativeText}
                          className={styles.borderRadiusImg}
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div className={styles.introduction}>
              <Row className="justify-content-center text-center">
                <Col xl={8} lg={8} md={10} sm={12} xs={12}>
                  <div className={styles.para}>
                    <div dangerouslySetInnerHTML={{ __html: scholarshipCountryData.bannerSection?.description }}></div>
                  </div>
                  <Button
                    id="applyNowBtn"
                    variant="primary"
                    size="lg"
                    className={`btn ${isFrappeOrJotFormClass(scholarshipCountryData?.meta?.jotforms[0]?.jotformid)}  ${styles.applyNow}`}
                  >
                    {" "}
                    Enquire Now{" "}
                  </Button>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <div
          id="popularScholarshipPrograms"
          className={styles.popularScholarshipPrograms}
          style={{ backgroundColor: scholarshipCountryData?.ScholarshipsPrograms?.SectionBgColor }}
        >
          <CountryPopularSholarshipProgramsComponent {...props} />
        </div>
        <div id="scholarshipAchievement">
          <StudentsAcheivents
            slug={`our-students-achievements?type=scholarship&scholarships_country.countryName=${scholarshipCountryData.scholarships_country.countryName}`}
          />
        </div>

        {scholarshipCountryData && scholarshipCountryData?.sscVideoTestimonials && (
          <div id="testimonials" style={{ marginTop: "40px" }}>
            <VideoTestimonials {...scholarshipCountryData.sscVideoTestimonials} />
          </div>
        )}

        {scholarshipCountryData && scholarshipCountryData?.faq && <FaqComponent {...scholarshipCountryData.faq} />}

        <div id="needGuidance">
          <NeedGuidance classname={`${isFrappeOrJotFormClass(scholarshipCountryData?.meta?.jotforms[0]?.jotformid)}`} />
        </div>
      </div>
    </>
  );
};
export default StudyAbroadScholarshipCountryComponent;
